import { render, staticRenderFns } from "./SelectaHeader.vue?vue&type=template&id=40ea927a"
import script from "./SelectaHeader.vue?vue&type=script&lang=ts"
export * from "./SelectaHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports